/* eslint-disable no-prototype-builtins */
import { takeEvery } from 'redux-saga/effects';
import type { EffectCreatorParams } from '@app/redux/types';
import { SET_GA } from '../consts';

export const onSetGA = ({ payload }: EffectCreatorParams<Dict>) => {
  if (typeof window !== 'undefined' && window.hasOwnProperty('ga')) {
    window.ga('set', payload);
  }
};

export default function* setGASaga() {
  yield takeEvery(SET_GA, onSetGA);
}
